import { app } from '../app';

app.config(config);

/** @ngInject */
function config($httpProvider) {
    $httpProvider.interceptors.push(interceptor);
}

/** @ngInject */
function interceptor(TokenService) {

    return {request};

    function request(config) {
        const token = TokenService.getAccessToken();
        if (token && config.url !== 'oauth/token' && !config.url.startsWith('https://')) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    }
}



// WEBPACK FOOTER //
// ./src/portal/config/auth-token-interceptor.config.js